/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from '../../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class UpdateAdvertiserApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  getAdvertiser(id: string): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['advertisers', id]),
      params: {}
    });
  }

  saveAdvertiser(model: any): Observable<any> {
    return this.client.request({
      method: 'POST',
      url: this.apiConfig.getVersionedUri(['advertisers', model.id]),
      body: model
    });
  }

  listElections(): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri('elections'),
      params: {
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        includeTests: false,
        orderBy: 'name',
        pageSize: 1001
      }
    });
  }
}
